<template>
  <div class="page" id="test">
    <section class="content-section secondary gallery" >
      <div class="section-title">
          <div class="section-title-line"></div>
          <h1>UNSER PORTFOLIO</h1>
          <div class="section-title-line"></div>
      </div>  
      <div class="gallery" v-if="itemsLoaded">
       <div class="gallery-col" v-for="n in this.cols" :key="n" :col="n" >
         <div class="gallery-item" v-for="(item, index) in portfolioList[n-1]" :key="index" >
          <img :src='item.src' /> </div>
        </div> 
          
      </div>
    </section>
  </div>
</template>

<script>
const axios = require("axios");
//https://github.com/paulcollett/vue-masonry-css
export default {
    name: "Referenzen",
    metaInfo: {
        title: "Referenzen und Portfolio",
        meta: [
            {
                vmid: "description",
                name: "description",
                content:
                    "In über 50 Jahren haben wir so einige Natursteinprodukte angefertigt und viele Kunden zufrieden gestellt. Hier erhalten Sie einen kleinen Einblick in unsere Arbeiten"
            },
            {
                vmid: "keywords",
                name: "keywords",
                content:
                    "Naturstein Portfolio, Naturstein Referenzen, Referenzen, Portfolio, Natursteinarbeiten, Natursteinprodukte, Naturstein Mönchengladbach"
            }
        ],
        links: [
            { rel: "canonical", href: "https://www.marmor-kunze.de/referenzen" }
        ]
    },
    data() {
        return {
            portfolioList: [],
            itemsLoaded: false,
            cols: 4,
            portfolio: []
        };
    },
    created() {
        let items = [];
        axios
            .post("https://www.marmor-kunze.de/static/php/portfolio.php")
            .then(response => {
                let data = response.data;
                for (var section in data) {
                    for (var item in data[section]) {
                        items.push({
                            src:
                                "https://www.marmor-kunze.de/static/portfolio/" +
                                section +
                                "/" +
                                data[section][item].name
                        });
                    }
                }
                items = items
                    .map(a => [Math.random(), a])
                    .sort((a, b) => a[0] - b[0])
                    .map(a => a[1]);
                this.portfolioList = this.chunk(
                    items,
                    Math.round(items.length / this.cols)
                );
                this.itemsLoaded = true;
            })
            .catch(error => {
                console.log(error);
            });
    },
    methods: {
        chunk(arr, size) {
            let chunked = [];
            for (let ele of arr) {
                let last = chunked[chunked.length - 1];
                if (!last || last.length === size) {
                    chunked.push([ele]);
                } else {
                    last.push(ele);
                }
            }
            return chunked;
        },
        createGroupedArray: function(arr, chunkSize) {
            var groups = [],
                i;
            for (i = 0; i < arr.length; i += chunkSize) {
                groups.push(arr.slice(i, i + chunkSize));
            }
            return groups;
        }
    }
};
</script>
j
<style>
</style>



// WEBPACK FOOTER //
// src/components/views/Referenzen.vue